import { render, staticRenderFns } from "./addCharing.vue?vue&type=template&id=085749d6&scoped=true"
import script from "./addCharing.vue?vue&type=script&lang=js"
export * from "./addCharing.vue?vue&type=script&lang=js"
import style0 from "./addCharing.vue?vue&type=style&index=0&id=085749d6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "085749d6",
  null
  
)

export default component.exports